import * as countries from 'i18n-iso-countries'
/* eslint-disable import/no-named-default */
import { default as enLocale } from 'i18n-iso-countries/langs/en.json'
import { default as fiLocale } from 'i18n-iso-countries/langs/fi.json'
import { default as svLocale } from 'i18n-iso-countries/langs/sv.json'
import { default as deLocale } from 'i18n-iso-countries/langs/de.json'
/* eslint-enable import/no-named-default */

countries.registerLocale(enLocale)
countries.registerLocale(fiLocale)
countries.registerLocale(svLocale)
countries.registerLocale(deLocale)

export default () => {
  const { sortIntl } = useIntl()
  const { language } = useLanguage()

  const alphaCodes = countries.getAlpha2Codes()
  const countryOptions = computed(
    () =>
      sortIntl(
        Object.keys(alphaCodes).map(
          value => ({ value, text: countries.getName(value, language.value)! }),
        ),
        ({ text }) => text,
      ),
  )

  return {
    ...countries,
    countryOptions,
  }
}
